// This function allow to reference chunks
__webpack_require__.k = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "chunk." + {531: "c3375deefac15983",731: "8a0a0ff0806b4f84",}[chunkId] + ".css"
}